import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPermissionsComponent } from './user-permissions.component';
import { AddPermissionsComponent } from './add-permissions/add-permissions.component';
import { EditPermissionsComponent } from './edit-permissions/edit-permissions.component';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    UserPermissionsComponent,
    AddPermissionsComponent,
    EditPermissionsComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    FormsModule,
    ReactiveFormsModule
]
})
export class UserPermissionsModule { }
